"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var amazon_config_store_type_script_client_1 = require("@amzn/amazon-config-store-type-script-client");
var I18nPriceFormatContext = /** @class */ (function () {
    function I18nPriceFormatContext(i18nCxFamily, i18nPriceformatCxProgram, i18nPriceformatLocale, i18nCurrency, i18nPriceformatCxId, i18nPriceformatType) {
        this._i18nCxFamily = i18nCxFamily;
        this._i18nPriceformatCxProgram = i18nPriceformatCxProgram;
        this._i18nPriceformatLocale = i18nPriceformatLocale;
        this._i18nCurrency = i18nCurrency;
        this._i18nPriceformatCxId = i18nPriceformatCxId;
        this._i18nPriceformatType = i18nPriceformatType;
    }
    I18nPriceFormatContext.prototype.toRawContext = function () {
        var context = new Map();
        context.set("i18n_cx_family", this._i18nCxFamily);
        context.set("i18n_priceformat_cx_program", this._i18nPriceformatCxProgram);
        context.set("i18n_priceformat_locale", this._i18nPriceformatLocale);
        context.set("i18n_currency", this._i18nCurrency);
        context.set("i18n_priceformat_cx_id", this._i18nPriceformatCxId);
        context.set("i18n_priceformat_type", this._i18nPriceformatType);
        return new amazon_config_store_type_script_client_1.QueryContext(context);
    };
    Object.defineProperty(I18nPriceFormatContext.prototype, "i18nCxFamily", {
        get: function () {
            return this._i18nCxFamily;
        },
        set: function (value) {
            this._i18nCxFamily = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(I18nPriceFormatContext.prototype, "i18nPriceformatCxProgram", {
        get: function () {
            return this._i18nPriceformatCxProgram;
        },
        set: function (value) {
            this._i18nPriceformatCxProgram = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(I18nPriceFormatContext.prototype, "i18nPriceformatLocale", {
        get: function () {
            return this._i18nPriceformatLocale;
        },
        set: function (value) {
            this._i18nPriceformatLocale = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(I18nPriceFormatContext.prototype, "i18nCurrency", {
        get: function () {
            return this._i18nCurrency;
        },
        set: function (value) {
            this._i18nCurrency = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(I18nPriceFormatContext.prototype, "i18nPriceformatCxId", {
        get: function () {
            return this._i18nPriceformatCxId;
        },
        set: function (value) {
            this._i18nPriceformatCxId = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(I18nPriceFormatContext.prototype, "i18nPriceformatType", {
        get: function () {
            return this._i18nPriceformatType;
        },
        set: function (value) {
            this._i18nPriceformatType = value;
        },
        enumerable: false,
        configurable: true
    });
    return I18nPriceFormatContext;
}());
exports.default = I18nPriceFormatContext;
